import { useState, useEffect } from 'react'
import type { Program } from '../types/program'
import { fetchProgramInfo } from '../utils'

export function useProgramInfo(programId: number | undefined, date?: string) {
  const [data, setData] = useState<Program | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        setError(null)
        setData(null)
        if (programId) {
          const program = await fetchProgramInfo(programId, date ?? '')
          setData(program)
        } else {
          setData(null)
        }
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    if (programId) load()
  }, [programId])

  return { data, isLoading, error }
}
